<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-03-21 09:14:28
 * @LastEditors: xgx
-->
<template>
    <div id="box" class="box">
        <div id="left" class="left">
            <div style="font-weight: 600;" class="title">组织架构</div>
            <div class="search">
                <a-input-search
                    v-model="organizationName"
                    placeholder="搜索组织架构名称"
                    size="large"
                    @search="search"
                >
                    <template #enterButton @click="search">
                        <img class="img" src="@/assets/images/search.jpg" />
                    </template>
                </a-input-search>
            </div>
            <div @click="closeAll">
                <img class="close-img" src="@/assets/images/close.jpg" /><span
                    class="close-name"
                    >全部收缩</span
                >
            </div>
            <div class="ant-tree" >
                <a-tree
                    show-line
                    :style="{height:heightLeft,overflowY:'auto',overflowX:'hidden'}"
                    :tree-data="treeData"
                    v-if="treeData.length > 0"
                    @select="onSelect"
                     :selectedKeys="checkedKeys"
                    :defaultExpandedKeys="defaultExpandedKeys"
                    :autoExpandParent="isCloseAll"
                >
                </a-tree>
            </div>
        </div>
        
         <div id="resize"></div>
        <div id="right" class="right">
            <div style="font-weight: 600;" class="right-name">申请清单-{{organizationNameTwo}}</div>
            <div class="top">
                <div style="margin-bottom:20px">
                     <el-button  v-if="codeData.indexOf('304') != -1" type="primary" @click="addAdminFn">新增申请</el-button
                    >
                     <a-dropdown v-if="codeData.indexOf('317') != -1">
                        <a-button @click="config" >提醒配置</a-button>
                      </a-dropdown>
                </div>
                <div style="margin-bottom:20px" class="search">
                      <a-select v-if="!isShowBtn" v-model="status" style="width: 318px;margin-right:12px;"  placeholder="按办理状态筛选" >
                            <a-select-option :value="item.id" v-for="(item,index) in grouplist" :key="index">{{item.groupName}}</a-select-option>
                        </a-select>
                         <a-select v-if="isShowBtn" v-model="status" style="width: 318px;margin-right:12px;margin-bottom:20px"  placeholder="按办理状态筛选" >
                            <a-select-option :value="item.id" v-for="(item,index) in grouplist" :key="index">{{item.groupName}}</a-select-option>
                        </a-select>
                     <a-input-group compact>
                        <a-select
                        v-model="selectName"
                        style="width: 140px; background: #ccc;"
                        >
                        <a-select-option
                            @click="selectFn(item.value)"
                            :key="index"
                            v-for="(item, index) in selectArr"
                        >
                            {{ item.label }}
                        </a-select-option>
                        </a-select>
                        <a-input
                        v-model="seachValue"
                        placeholder="请输入搜索内容"
                        style="width: 173px"
                        />
                    </a-input-group>
                    <el-button class="search-box" type="primary" @click="searchTwo">查询</el-button>
                </div>
            </div>
            <coententTable
                :y="height"
                @handleTableChange="handleTableChange"
                @onShowSizeChange="onShowSizeChange"
                :columns="type == 1 ? columns : columnsTwo"
                :dataSource="dataSource"
                :customSlot="customSlot"
                :loading="loading"
            >
            <template v-slot:applyType="scopeVal">
                 {{scopeVal.scope.applyType==0?'公民':'法人'}}
            </template>
              <template v-slot:status="scopeVal">
                 {{scopeVal.scope.status==0?'待受理':scopeVal.scope.status==1?'办理中':'已办结'}}
            </template>
             <template v-slot:phone="scopeVal">
                 {{scopeVal.scope.phone || scopeVal.scope.landlinePhone}}
            </template>
                <template v-slot:operation="scopeVal">
                    <div
                        @click="lookOver(scopeVal.scope)"
                        v-if="codeData.indexOf('303') != -1"
                        class="btnTwo"
                        >查看</div
                    >
                    
                </template>
            </coententTable>
            <div class="pagination" id="pagination">
                <a-pagination
                    :current="pagination.current"
                    :pageSize="pagination.pageSize"
                    show-size-changer
                    show-quick-jumper
                    :total="pagination.total"
                    @change="onShowSizeChange"
                    @showSizeChange="handleTableChange"
                    :page-size-options="pagination.pageSizeOptions"
                    :show-total="(total) => `共 ${pagination.total} 条`"
                />
            </div>
        </div>
        <ApplicationDetails @closeTwo="closeTwo" @close="close" v-show="isDetail"  :visible="isDetail" :itemData="itemData"/>
        <ConfigSeting @handleOk="handleOk" :organization="organization" :organizationNameTwo="organizationNameTwo" @handleCancel="handleCancel" :configShow="configShow" v-if="configShow"/>
    </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import { selectListPage,organTree} from "./index.js";
import ApplicationDetails from './components/application_details.vue';
import ConfigSeting from './components/configSeting.vue'
export default {
    data() {
        return {
            type: 1,
            height: 0,
            seachValue:"",
            isCloseAll: false,
            isDetail:false,
            checkedKeys:[],
            heightLeft:0,
            grouplist:[
                 {
                    groupName:'全部',
                    id:undefined,
                },
                {
                    groupName:'待受理',
                    id:0,
                },
                 {
                    groupName:'办理中',
                    id:1,
                },
                 {
                    groupName:'已办结',
                    id:2,
                }
            ],//分组列表
            expandedKeys: [],
            selectedKeys: [],
            status:undefined,
            selectName:'姓名/名称',
            selectkey:'interviewTheme',
            selectArr:[
                {
                    'label':'姓名/名称',
                    'value':'interviewTheme'
                },
                {
                    'label':'联系电话',
                    'value':'hostUnit'
                }
            ],
            treeData: [],
            organization: "",
            sortValue:"",
            organizationName: "",
            organizationNameTwo:'',
            name: "",
            loading:false,
            role: undefined,
            columns: [
                {
                    title: "申请类型",
                    dataIndex: "applyType",
                    scopedSlots: { customRender: "applyType" },
                    ellipsis: true,
                    width: 120,
                },
                {
                    title: "姓名/企业名称",
                    dataIndex: "name",
                     ellipsis: true,
                    width: 300,
                },
                {
                    title: "联系电话",
                    dataIndex: "phone",
                     scopedSlots: { customRender: "phone" },
                      ellipsis: true,
                    width: 120,
                },
                {
                    title: "流转单位",
                    dataIndex: "circulationUnit",
                      ellipsis: true,
                    width: 120,
                },
                 {
                    title: "办理状态",
                    dataIndex: "status",
                    scopedSlots: { customRender: "status" },
                     ellipsis: true,
                    width: 120,
                },
                {
                    title: "办理单位",
                    dataIndex: "handlingUnit",
                     ellipsis: true,
                    width: 120,
                },
                 {
                    title: "提交时间",
                    dataIndex: "creationTime",
                     ellipsis: true,
                    width: 200,
                },
                {
                    title: "操作",
                    dataIndex: "operate",
                    scopedSlots: { customRender: "action" },
                    fixed: "right",
                    width: 100,
                },
            ],
            customSlot: [
                {
                    name: "applyType",
                    customRender: "applyType",
                },
                {
                    name: "status",
                    customRender: "status",
                },
                {
                    name: "phone",
                    customRender: "phone",
                },
            ],
            pagination: {
                current: 1,
                pageSize: 15,
                total: 0,
                pageSizeOptions: ["15", "25", "35"],
            },
            dataSource: [],
            cancelPreAuth:false,
            codeData:[],
            itemData:{},
            configShow:false,
            defaultExpandedKeys:[],
            isShowBtn:false,
        };
    },
    components: {
        coententTable,
        ApplicationDetails,
        ConfigSeting,
    },
    mounted() {
        this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
        this.heightLeft = `${document.documentElement.clientHeight - 290}px`;
        this.getOrganTree();
        this.$nextTick(()=>{
            var left = document.getElementById("left");
            var box = document.getElementById("box");
            var right = document.getElementById("right");
            var pagination = document.getElementById("pagination");
            left.style.width = 250 + "px";
            right.style.width = (box.clientWidth - 250 - 5) + "px";
            pagination.style.width = (box.clientWidth - 250 + 5) + "px";
        })
        this.getLeftMove();
    },
    methods: {
        getLeftMove(){
            var resize = document.getElementById("resize");
            var left = document.getElementById("left");
            var right = document.getElementById("right");
            var box = document.getElementById("box");
            var pagination = document.getElementById("pagination");
            let _this = this;
            resize.onmousedown = function(e){
                var startX = e.clientX;
                resize.left = resize.offsetLeft;
                document.onmousemove = function(e){
                var endX = e.clientX;

                var moveLen = resize.left + (endX - startX);
                var maxT = box.clientWidth - resize.offsetWidth;
                if(moveLen<250) moveLen = 250;
                if(moveLen>600) moveLen = 600;  
                if(moveLen>maxT-150) moveLen = maxT-150;

                resize.style.left = moveLen;
                left.style.width = moveLen + "px";
                right.style.width = (box.clientWidth - moveLen - 5) + "px";
                pagination.style.width = (box.clientWidth - moveLen + 5) + "px";
                if((box.clientWidth - moveLen - 5) < 1000){
                       _this.height = document.documentElement.clientHeight - 490;
                       document.getElementsByClassName('ant-pagination')[0].style.marginRight = 0;
                       document.getElementsByClassName('ant-pagination-options')[0].style.display = 'none';
                 }else{
                      document.getElementsByClassName('ant-pagination')[0].style.marginRight = '124px';
                       document.getElementsByClassName('ant-pagination-options')[0].style.display = 'block';
                 }
                 if ((box.clientWidth - moveLen) < 720) {
                            _this.isShowBtn = true;
                        } else {
                            _this.isShowBtn = false;
                        }
                }
                document.onmouseup = function(evt){
                document.onmousemove = null;
                document.onmouseup = null; 
                resize.releaseCapture && resize.releaseCapture();
                }
                resize.setCapture && resize.setCapture();
                return false;
            }
        },
        config(){
            this.configShow = true;
        },
        handleCancel(){
            this.configShow = false;
        },
        handleOk(){
            this.configShow = false;
            this.getListPage();
        },  
        lookOver(item){
             this.itemData = item;
            this.isDetail = true;
        },
        addAdminFn() {
            this.$router.push({
                path: "/index/applicationlist/add",
                query: { 
                    title: "新增申请",
                    isEdit: false,
                    islast:true,
                },
            });
        },
        closeAll() {
            this.isCloseAll = false;
            this.$nextTick(() => {
                this.isCloseAll = true;
            });
        },
        onSelect(key, event) {
            if(key.length == 0){
                return false;
            }
            if(key.length > 0){
                this.organization = key[0];
                this.checkedKeys = [this.organization]
                this.organizationNameTwo = event.node._props.title;
                this.pagination.current = 1;
                this.getListPage();
            }
           
        },
        search() {
            this.getOrganTree();
        },
        searchTwo(){
            this.pagination.current = 1;
            this.getListPage()
        },
        // 切换 搜索
        selectFn(value) {
            this.selectkey = value;
            console.log(this.selectkey,'dsadsa')
        },
        onShowSizeChange(current) {
            this.pagination.current = current;
            this.getListPage();
        },
        handleTableChange(page,pageSize) {
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getList();
        },
        //授权列表数据
        getListPage() {
            const _this = this;
            this.loading = true;
            this.dataSource = [];
            let reqData = {
                current: _this.pagination.current,
                siteId: sessionStorage.getItem("siteId"),
                size: _this.pagination.pageSize,
                organizationId: _this.organization,
                name: this.selectkey=='interviewTheme'?_this.seachValue:"",
                phone: this.selectkey=='hostUnit'?_this.seachValue:"",
                status:this.status,
            };
            selectListPage(reqData).then((res) => {
                if (res.code == 0) {
                    _this.dataSource = JSON.parse(JSON.stringify(res.data.records));
                    _this.pagination.current = res.data.current;
                    _this.pagination.pageSize = res.data.size;
                    _this.pagination.total = res.data.total;
                    this.height = 0;
                    if(_this.pagination.total > 0){
                         this.height = document.documentElement.clientHeight - 420;
                          this.heightLeft = `${document.documentElement.clientHeight - 290}px`;
                        window.onresize = () => {
                            return (() => {
                                this.height = document.documentElement.clientHeight - 420;
                                 this.heightLeft = `${document.documentElement.clientHeight - 290}px`;
                                 var left = document.getElementById("left");
                                var box = document.getElementById("box");
                                var right = document.getElementById("right");
                                var pagination = document.getElementById("pagination");
                                left.style.width = 250 + "px";
                                right.style.width = (box.clientWidth - 250 - 5) + "px";
                                pagination.style.width = (box.clientWidth - 250 + 5) + "px";
                                console.log((box.clientWidth - 250 - 5),'sssssss')
                                if ((box.clientWidth - 250 - 5) < 720) {
                                        _this.isShowBtn = true;
                                    } else {
                                        _this.isShowBtn = false;
                                    }
                            })();
                        };
                    }
                    if (_this.pagination.current != 1 && _this.dataSource.length == 0) {
                    _this.pagination.current--;
                    _this.getListPage();
                    }
                    _this.loading = false;
                }
            });
        },
        getOrganTree(){
            const _this = this;
             this.loading = true;
            organTree({name:_this.organizationName}).then(res=>{
                if(res.code == 0){
                    if(res.data.length > 0){
                        this.organization = res.data[0].id;
                        this.organizationNameTwo = res.data[0].organizationName;
                        this.defaultExpandedKeys = [res.data[0].id];
                        this.checkedKeys = [this.organization];
                    }
                    this.getListPage();
                    let options = JSON.stringify(res.data)
                        .replace(/organizationName/g, "title")
                        .replace(/id/g, "key");
                    _this.treeData = JSON.parse(options);
                }
            })
        },
        close(){
            this.isDetail = false;
            this.getListPage();
        },
        closeTwo(){
            this.isDetail = false;
        }
    },
};
</script>

<style lang="less" scoped>
.box {
    display: flex;
    width: 100%;
    height: 100%;
    max-height: calc(94% - 11px);
    //position: relative;
    .left {
        width: 250px;
        font-size: 14px;
        color: #000;
        padding: 24px;
        height: calc(107.5% - 3px);
        border-right: solid 1px #E4E7ED;
        .title {
            margin-bottom: 24px;
        }
        .search {
            margin-bottom: 12px;
        }
        /deep/ .ant-btn-primary {
            background: #1890ff;
            padding: 0 5px;
        }
        /deep/ input::-webkit-input-placeholder {
            color: #415058;
        }
        /deep/ .ant-input {
            background: #f7f7f7;
        }
    }
    .right {
        flex: 1;
        height: 100%;
        width: 100%;
        font-size: 14px;
        padding-top: 24px;
        //border-left: solid 2px #f2f3f5;
        padding-bottom: 33px;
        width: 500px;
        .right-name {
            padding-left: 24px;
            color: #000;
        }
        .log-box {
            //border-bottom: solid 1px #dcdfe6;
            display: flex;
            margin-left: 24px;
            margin-right: 24px;
            margin-top: 24px;
            .log {
                padding: 10px 20px;
                border-top: solid 1px #dcdfe6;
                border-left: solid 1px #dcdfe6;
                cursor: pointer;
                border-bottom: solid 1px #dcdfe6;
            }
            .log:last-child {
                border-right: solid 1px #dcdfe6;
                border-top-right-radius: 10px;
            }
            .log:first-child {
                border-top-left-radius: 10px;
            }
        }
        .search {
            display: flex;
            flex-wrap: wrap;
            /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
            /deep/ .ant-input-group{
                width: auto;
            }
        }

        /deep/ .ant-table-wrapper {
           // width: 100%;
        }
    }
}
.top {
    padding: 24px;
    padding-bottom: 0px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .search {
        display: flex;
    }

    .add-img {
        margin-top: -2px;
        margin-right: 3px;
    }
}
.ant-tree {
    overflow: hidden;
    overflow-y: auto;
}
.dir {
    height: 1px;
    background: #dcdfe6;
    margin-left: 330px;
    margin-right: 24px;
    margin-top: -1px;
}
.middle {
    height: calc(113% - 4px);
    border-right: solid 1px #f4f4f6;
}
.tr-one {
    display: flex;
}
.quan {
    width: 24px;
    height: 24px;
    background: #fff;
    border: solid 1px #ccc;
    border-radius: 50%;
}
.close-name {
    color: #303133;
    font-weight: 400;
    margin-top: 4px;
}
.close-img {
    margin-top: -1px;
    margin-right: 4px;
    cursor: pointer;
}
.Status1{
    color:#67c23a;
}
.Status2{
    color:#f56c6c
}
.btn{
  margin-top: 24px;
  text-align: right;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #E4E7ED 1px;
  position:absolute;
  bottom: 0;
  width: calc(100% - 530px);
  padding-right: 24px;
  margin-left: -5px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
.overflow{
  overflow:hidden; 
  white-space: nowrap;
  text-overflow: ellipsis; 
  -o-text-overflow:ellipsis;
  width: 150px;
}
/deep/ .ant-spin-nested-loading{
    width: 100%;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
 .el-button--primary {
  background: #176de6;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .ant-dropdown-trigger {
  border-radius: 3px;
   height: 40px;
   margin-left: 12px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
}
#resize{
  width:5px;
  height:100%;
  cursor: w-resize;
  float:left;
}
/deep/ .table{
    margin-top: 0px;
}
.search-box{
    margin-left: 12px;
}
</style>